import { IApplicationLink, IApplicationRoutes } from 'ops-lib';
const NAMESPACE = 'APP';
const INITIAL_STATE: AppState = {
  applicationId: -1,
  navigationLinks: null, // <Array<IApplicationLink>>{},
  applicationRoutes: <Array<IApplicationRoutes>>{},
  reloadData: null,
  version: null,
};

export const AppActions = {
  INIT: `${NAMESPACE}.INIT`,
  SET_APP_ID: `${NAMESPACE}.SET_APP_ID`,
  SET_NAVIGATION: `${NAMESPACE}.SET_NAVIGATION`,
  SET_EXTERNAL_ROUTES: `${NAMESPACE}.SET_EXTERNAL_ROUTES`,
  RELOAD_DATA: `${NAMESPACE}.RELOAD_DATA`,
  SET_APP_VERSION: `${NAMESPACE}.SET_APP_VERSION`,
};

export function AppReducer(state: AppState, action: any) {
  const temp = {...state};
  switch (action.type) {
    case AppActions.INIT:
      return {...INITIAL_STATE};
    case AppActions.SET_NAVIGATION:
      temp.navigationLinks = action.payload;
      return temp;
    case AppActions.SET_APP_ID:
      temp.applicationId = action.payload;
      return temp;
    case AppActions.SET_EXTERNAL_ROUTES:
      temp.applicationRoutes = action.payload;
      return temp;
    case AppActions.RELOAD_DATA:
      temp.reloadData = action.payload;
      return temp;
    case AppActions.SET_APP_VERSION:
      state.version = action.payload;
      return state;
    default:
      return temp;
  }
}

export interface AppState {
  applicationId: number;
  navigationLinks: Array<IApplicationLink>;
  applicationRoutes: Array<IApplicationRoutes>;
  reloadData: boolean;
  version: string;
}
